import React from "react";

function Signup() {
  return <h1 className="sign-up">SIGN UP</h1>;
}

export default Signup;
